// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8bab40a5","285":"8dffd62f","326":"4b107382","328":"e3b0ef57","383":"8b36792a","453":"51f8a842","503":"9cf7225f","525":"2fda0cad","573":"3ec86f20","586":"4a3ddc1b","588":"1d3fa75e","771":"ab3e855a","834":"8668ef8d","887":"ee85097f","889":"f9aba558","960":"95b69551"}[chunkId] + ".chunk.js";
};